import type { PickAnalyticsEventAttributes } from '../../../../types'
import { analyticsEvents } from '../../integration/analytics-multiplatform-sdk'

export const OrderDetails = (attributes: PickAnalyticsEventAttributes<'OrderDetails'>) => {
  const { OrderDetails, ReorderOrigin } = analyticsEvents
  return new OrderDetails(
    attributes.orderId,
    attributes.orderStatus,
    ReorderOrigin[attributes.reorderOrigin]
  )
}

export const OngoingOrderDetailsFirstViewed = (
  attributes: PickAnalyticsEventAttributes<'OngoingOrderDetailsFirstViewed'>
) => {
  const { OngoingOrderDetailsFirstViewed } = analyticsEvents
  return new OngoingOrderDetailsFirstViewed(attributes.orderId)
}

export const DownloadPressed = (attributes: PickAnalyticsEventAttributes<'DownloadPressed'>) => {
  const { DownloadPressed, DownloadPressedSource, OsPicked } = analyticsEvents
  return new DownloadPressed(
    DownloadPressedSource[attributes.downloadPressedSource],
    OsPicked[attributes.osPicked]
  )
}

export const ReorderButtonPressed = (
  attributes: PickAnalyticsEventAttributes<'ReorderButtonPressed'>
) => {
  const { ReorderButtonPressed, ReorderOrigin } = analyticsEvents
  return new ReorderButtonPressed(
    attributes.originalOrderId,
    ReorderOrigin[attributes.origin],
    attributes.storeId,
    attributes.storeAddressId
  )
}
